import { ClearOutlined as ClearOutlinedIcon } from '@mui/icons-material';
import Button from '@mui/material/Button';
import { useContext } from 'react';

import { defaultSearchParam } from './constants';
import { ApplicationContext } from '../../../../../../shared/source/context/context';

import type { FunctionComponent, MouseEventHandler } from 'react';

type CancelSearchButtonProps = { readonly onClick?: MouseEventHandler };

export const CancelSearchButton: FunctionComponent<CancelSearchButtonProps> = ({ onClick }) => {
    const { actions, applicationState, translate } = useContext(ApplicationContext);

    const handleClick: MouseEventHandler = (event): void => {
        const params = applicationState.locationSearchParams;

        params.delete(defaultSearchParam);
        actions.setLocationSearchParams(params);
        onClick?.(event);
    };

    return (
        <Button color="secondary" startIcon={<ClearOutlinedIcon />} onClick={handleClick}>
            {translate('common.cancel')}
        </Button>
    );
};
